import { useEffect, useState } from "react";
import { Bar, Pie } from "react-chartjs-2";
import { formatToHhMmSs } from "../../../newUtils/timeFormatter";
import { Box, FormControl, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField } from "@mui/material";

const TrendReportChartSKUBreakdown = (props) => {

    const [data, setData] = useState([])

    const [labels, setLabels] = useState([])

    const [duration, setDuration] = useState([])
    const [oee, setOee] = useState([])

    const [backgroundColors, setBackgroundColors] = useState([])
    const [tableBackgroundColors, setTableBackgroundColors] = useState([])
    const [hoveredId, setHoveredId] = useState(null)
    const [prevHoveredId, setPrevHoveredId] = useState(null)

    const [totalSec, setTotalSec] = useState(0)

    const [tableData, setTableData] = useState([])

    const [orderBy, setOrderBy] = useState("duration")
    const [order, setOrder] = useState("desc")

    const [skuSorting, setSkuSorting] = useState("top10duration")

    const [totalOtherDataValue, setTotalOtherDataValue] = useState(0)
    const [totalOtherOeeValue, setTotalOtherOeeValue] = useState(0)

    useEffect(() => {
        parseAggregateData(props.sku_aggregate_dict)
        setSkuSorting("top10duration")
        setOrderBy("duration")
        setOrder("desc")
        // onChangeSkuSorting({ target: { value: "top10oee" } })
    }, [props.sku_aggregate_dict])

    // useEffect(() => {
    //     onChangeSkuSorting({ target: { value: "top10oee" } })
    // }, [])

    // useEffect(() => {
    //     if (props.type === "Duration") {
    //         onRequestSort(null, 'duration', 'desc')
    //     }
    //     else {
    //         onRequestSort(null, 'oee', 'desc')
    //     }

    //     parseAggregateData(props.sku_aggregate_dict)
    // }, [props.type])

    const bgColorsArray = createGradientSteps(11, "rgba(10, 113, 206, 1)")

    const parseAggregateData = (data, firstLoad) => {
        let sorted_sku_aggregate_dict = [...props.sku_aggregate_dict].sort((a, b) => b.efficiency - a.efficiency)

        let efficiency_sorted_sku_aggregate_dict = [...props.sku_aggregate_dict]
        let duration_sorted_sku_aggregate_dict = [...props.sku_aggregate_dict]

        duration_sorted_sku_aggregate_dict = duration_sorted_sku_aggregate_dict.sort((a, b) => b.actual_time_seconds - a.actual_time_seconds)
        efficiency_sorted_sku_aggregate_dict = efficiency_sorted_sku_aggregate_dict.sort((a, b) => b.efficiency - a.efficiency)
        
        const newLabels = []
        let newData = []
        let newTotalOtherDataValue = 0
        let newOee = []
        let newTotalOtherOeeValue = 0
        const newDuration = []
        const newTableData = []
        const newBackgroundColors = []

        // if (props.type === "OEE") {
        //     sorted_sku_aggregate_dict = sorted_sku_aggregate_dict.sort((a, b) => b.efficiency - a.efficiency)
        // }
        // else {
        //     sorted_sku_aggregate_dict = sorted_sku_aggregate_dict.sort((a, b) => b.actual_time_seconds - a.actual_time_seconds)
        // }

        let totalSec = 0
        const newBgColorsArray = createGradientSteps(sorted_sku_aggregate_dict.length, "rgba(10, 113, 206, 1)")
        sorted_sku_aggregate_dict.forEach((item, i) => {
            totalSec += item.actual_time_seconds,
            sorted_sku_aggregate_dict[i].durationColor = newBgColorsArray[duration_sorted_sku_aggregate_dict.findIndex((x) => x.product_name === item.product_name && x.product_desc === item.product_desc)]
            sorted_sku_aggregate_dict[i].efficiencyColor = newBgColorsArray[efficiency_sorted_sku_aggregate_dict.findIndex((x) => x.product_name === item.product_name && x.product_desc === item.product_desc)]
        })
        
        setTableBackgroundColors(newBgColorsArray)

        sorted_sku_aggregate_dict = sorted_sku_aggregate_dict.sort((a, b) => b.actual_time_seconds - a.actual_time_seconds)

        let otherData = {
            value: 0,
            duration: 0,
            name: "Other",
            description: "",
            color: "#FEDD66"
        }
        let otherOee = {
            value: 0,
            name: "Other",
            description: "",
            color: "#FEDD66",
        }

        sorted_sku_aggregate_dict.forEach((item, i) => {
            if (i < 10) {
                newData.push({
                    value: ((item.actual_time_seconds / totalSec) * 100).toFixed(1),
                    duration: item.actual_time_seconds,
                    name: `${item.product_name}`,
                    description: `${item.product_desc}`,
                    color: item.durationColor,
                })
                newOee.push({
                    value: item.efficiency,
                    name: `${item.product_name}`,
                    description: `${item.product_desc}`,
                    color: item.efficiencyColor,
                })
                newLabels.push(`${item.product_name} (${item.product_desc})`)
            }
            else {
                otherData.value += ((item.actual_time_seconds / totalSec) * 100)
                otherData.duration += item.actual_time_seconds
                otherOee.value += item.efficiency
            }

            newDuration.push(item.actual_time_seconds)

            newTableData.push({
                name: item.product_name,
                description: item.product_desc,
                duration: item.actual_time_seconds,
                oee: item.efficiency,
                original_id: i,
                duration_id: duration_sorted_sku_aggregate_dict.findIndex((x) => x.product_name === item.product_name && x.product_desc === item.product_desc),
                efficiency_id: efficiency_sorted_sku_aggregate_dict.findIndex((x) => x.product_name === item.product_name && x.product_desc === item.product_desc),
                durationColor: newBgColorsArray[duration_sorted_sku_aggregate_dict.findIndex((x) => x.product_name === item.product_name && x.product_desc === item.product_desc)],
                efficiencyColor: newBgColorsArray[efficiency_sorted_sku_aggregate_dict.findIndex((x) => x.product_name === item.product_name && x.product_desc === item.product_desc)]
            })

            newBackgroundColors.push(newBgColorsArray[i])   
        })

        if (sorted_sku_aggregate_dict.length > 10) {
            newLabels.push("Other")
            newData.push(otherData)
            newOee.push(otherOee)
        }

        newOee = newOee.sort((a, b) => b.value - a.value)

        setData(newData)
        setOee(newOee)

        setTotalOtherDataValue(newTotalOtherDataValue)
        setTotalOtherOeeValue(newTotalOtherOeeValue)

        setTotalSec(totalSec)

        setLabels(newLabels)

        setDuration(newDuration)


        setTableData(newTableData)

        setBackgroundColors(newBackgroundColors)

        

        // if (firstLoad) {
        //     onChangeSkuSorting({ target: { value: "top10oee" } })
        // }
    }

    function createGradientSteps(steps, baseColor) {
        // Extract the RGBA values from the base color string
        const rgba = baseColor.match(/\d+/g).map(Number);
        const [r, g, b, a] = rgba;
    
        // Initialize the gradient array with the base color
        const gradient = [baseColor];
    
        // Define the target light gray color
        const targetGray = 240;
    
        // Calculate the step increments for each color channel
        const rStep = (targetGray - r) / (steps - 1);
        const gStep = (targetGray - g) / (steps - 1);
        const bStep = (targetGray - b) / (steps - 1);
    
        // Generate the gradient colors
        for (let i = 1; i < steps + 1; i++) {
            const newR = Math.round(r + rStep * i);
            const newG = Math.round(g + gStep * i);
            const newB = Math.round(b + bStep * i);
            gradient.push(`rgba(${newR}, ${newG}, ${newB}, ${a})`);
        }
    
        return gradient;
    }

    const onRequestSort = (event, property, forceOrder) => {
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = forceOrder ? forceOrder : isAsc ? 'desc' : 'asc';
        setOrder(newOrder);
        setOrderBy(property);

        const sortedData = [...tableData].sort((a, b) => {
            if (a[property] < b[property]) {
                return newOrder === 'asc' ? -1 : 1;
            }
            if (a[property] > b[property]) {
                return newOrder === 'asc' ? 1 : -1;
            }
            return 0;
        });
    
        setTableData(sortedData);
    };

    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    const onHover = (id) => {
        // console.log(id);
        
        setHoveredId(id)
        setPrevHoveredId(hoveredId)
        if (id === hoveredId) {
            return
        }
        const newData = [...data]
        const newOee = [...oee]
        if (skuSorting === "top10duration" || skuSorting === "bottom10duration" || skuSorting === "allduration") {
            newData.forEach((item, i) => {
                if (`${item.name} ${item.description}` === id || item.name === id ||  id === null) {
                    if (item.name === "Other" && item.description === "") {
                        newData[i].color = '#FEDD66'
                    }
                    else {
                        let found = tableData.find((x) => {
                            if (x.name === item.name) {
                                if (x.description === item.description || (!x.description && !item.description)) {
                                    return true
                                }
                                else {
                                    return false
                                }
                            }
                        })
                        newData[i].color = found && found.durationColor ? found.durationColor : 'black'
                    }
                }
                else {
                    newData[i].color = '#F3F8FC'
                }
            })
        }
        else {
            newOee.forEach((item, i) => {
                if (`${item.name} ${item.description}` === id || id === null) {
                    if (item.name === "Other" && item.description === "") {
                        newOee[i].color = '#FEDD66'
                    }
                    else {
                        let found = tableData.find((x) => x.name === item.name && x.description === item.description)
                        newOee[i].color = found && found.efficiencyColor ? found.efficiencyColor : 'black'
                    }
                }
                else {
                    newOee[i].color = '#F3F8FC'
                }
            })
        }
        setData(newData)
        setOee(newOee)
    }

    const onChangeSkuSorting = (event) => {
        setSkuSorting(event.target.value)
        parseAggregateData(props.sku_aggregate_dict)

        const newData = []
        const newOee = []
        const newLabels = []
        let totalSec = 0
        let parsed_sku_aggregate_dict = [...props.sku_aggregate_dict]

        let efficiency_sorted_sku_aggregate_dict = [...props.sku_aggregate_dict]
        let duration_sorted_sku_aggregate_dict = [...props.sku_aggregate_dict]

        duration_sorted_sku_aggregate_dict = duration_sorted_sku_aggregate_dict.sort((a, b) => b.actual_time_seconds - a.actual_time_seconds)
        efficiency_sorted_sku_aggregate_dict = efficiency_sorted_sku_aggregate_dict.sort((a, b) => b.efficiency - a.efficiency)

        if (event.target.value === "top10oee") {
            parsed_sku_aggregate_dict = parsed_sku_aggregate_dict.sort((a, b) => b.efficiency - a.efficiency);
            onRequestSort(null, 'oee', 'desc')
        }
        else if (event.target.value === "bottom10oee") {
            parsed_sku_aggregate_dict = parsed_sku_aggregate_dict.sort((a, b) => a.efficiency - b.efficiency)
            onRequestSort(null, 'oee', 'asc')
        }
        else if (event.target.value === "top10duration") {
            parsed_sku_aggregate_dict = parsed_sku_aggregate_dict.sort((a, b) => b.actual_time_seconds - a.actual_time_seconds)
            onRequestSort(null, 'duration', 'desc')
        }
        else if (event.target.value === "bottom10duration") {
            parsed_sku_aggregate_dict = parsed_sku_aggregate_dict.sort((a, b) => a.actual_time_seconds - b.actual_time_seconds)
            onRequestSort(null, 'duration', 'asc')
        }
        else if (event.target.value === "alloee") {
            parsed_sku_aggregate_dict = parsed_sku_aggregate_dict.sort((a, b) => b.efficiency - a.efficiency)
            onRequestSort(null, 'oee', 'desc')
        }
        else if (event.target.value === "allduration") {
            parsed_sku_aggregate_dict = parsed_sku_aggregate_dict.sort((a, b) => b.actual_time_seconds - a.actual_time_seconds)
            onRequestSort(null, 'duration', 'desc')
        }

        const newBgColorsArray = createGradientSteps(parsed_sku_aggregate_dict.length, "rgba(10, 113, 206, 1)")
        parsed_sku_aggregate_dict.forEach((item, i) => {
            totalSec += item.actual_time_seconds,
            parsed_sku_aggregate_dict[i].durationColor = newBgColorsArray[duration_sorted_sku_aggregate_dict.findIndex((x) => x.product_name === item.product_name && x.product_desc === item.product_desc)]
            parsed_sku_aggregate_dict[i].efficiencyColor = newBgColorsArray[efficiency_sorted_sku_aggregate_dict.findIndex((x) => x.product_name === item.product_name && x.product_desc === item.product_desc)]
        })

        let otherData = {
            value: 0,
            duration: 0,
            name: "Other",
            description: "",
            color: "#FEDD66"
        }
        let otherOee = {
            value: 0,
            name: "Other",
            description: "",
            color: "#FEDD66",
        }
        parsed_sku_aggregate_dict.forEach((item, i) => {
            if (i < 10) {
                newData.push({
                    value: ((item.actual_time_seconds / totalSec) * 100).toFixed(1),
                    duration: item.actual_time_seconds,
                    name: `${item.product_name}`,
                    description: `${item.product_desc}`,
                    color: item.durationColor,
                })
                newOee.push({
                    value: item.efficiency,
                    name: `${item.product_name}`,
                    description: `${item.product_desc}`,
                    color: item.efficiencyColor,
                })
                newLabels.push(`${item.product_name} (${item.product_desc})`)
            }
            else {
                otherData.value += ((item.actual_time_seconds / totalSec) * 100)
                otherData.duration += item.actual_time_seconds
                otherOee.value += item.efficiency
            }
        })
        if (parsed_sku_aggregate_dict.length > 10) {
            if (event.target.value === "top10oee" || event.target.value === "bottom10oee") {
                otherOee.value = otherOee.value / (parsed_sku_aggregate_dict.length - 9)
            }
            newLabels.push("Other")
            newData.push(otherData)
            newOee.push(otherOee)
        }

        setData(newData)
        setOee(newOee)
        setLabels(newLabels)

    }
    return (
        <div onMouseLeave={() => onHover(null)} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "24px 24px 0px 24px"  }}>
            <div style={{ height: "240px", width: "240px", marginTop: "-78px", }}>
                <div style={{ marginBottom: "24px" }} onMouseEnter={() => onHover(null)}>
                    <TextField
                        onMouseEnter={() => onHover(null)}
                        sx={{ height: "40px", width: "100%" }}
                        InputProps={{ sx: { height: "40px" } }}
                        value={skuSorting}
                        onChange={onChangeSkuSorting}
                        select
                        label="View By"
                    >
                        <MenuItem value={"top10oee"}>Top 10 by OEE</MenuItem>
                        <MenuItem value={"bottom10oee"}>Bottom 10 by OEE</MenuItem>
                        <MenuItem value={"top10duration"}>Top 10 by Duration</MenuItem>
                        {/* <MenuItem value={"bottom10duration"}>Bottom 10 by Duration</MenuItem> */}
                        {/* <MenuItem value={"alloee"}>All products by OEE</MenuItem>
                        <MenuItem value={"allduration"}>All products by Duration</MenuItem> */}
                    </TextField>
                </div>
                {skuSorting === "top10duration" || skuSorting === "bottom10duration" || skuSorting === "allduration" ? (
                    <Pie
                        data={{
                            labels: labels,
                            datasets: [
                                {
                                    data: data.map(a => a.value),
                                    backgroundColor: data.map(a => a.color),
                                }
                            ]
                        }}
                        options={{
                            onHover: (event, chartElement) => {
                                if (chartElement[0] && chartElement[0].element) {
                                    if (hoveredId !== `${data[chartElement[0].index].name} ${data[chartElement[0].index].description}` &&
                                        `${data[chartElement[0].index].name} ${data[chartElement[0].index].description}` !== 'Other'
                                    ) {
                                        onHover(`${data[chartElement[0].index].name} ${data[chartElement[0].index].description}`)
                                    }
                                }
                                else {
                                    onHover(null)
                                }
                                
                            },
                            elements: {
                                arc: {
                                    borderWidth: data.length > 1 ? 2 : 0,
                                },
                            },
                            plugins: {
                                legend: {
                                    display: false,
                                },
                                tooltip: {
                                    yAlign: "top",
                                    xAlign: "center",
                                    position: "nearest",
                                    backgroundColor: "#FFF",
                                    multiKeyBackground: "#fff",
                                    titleColor: "#111827",
                                    titleFont: {
                                        weight: 'bold',
                                        size: "14px",
                                    },
                                    bodyColor: "#666666",
                                    bodyFont: {
                                        weight: 'normal',
                                        // size: "14px",
                                    },
                                    boxWidth: 4,
                                    boxPadding: 4,
                                    borderColor: "rgba(122, 122, 122, 0.2)",
                                    borderWidth: 1,
                                    callbacks: {
                                        title: function(context) {
                                            return `Product: ${context[0].label}`;
                                        },
                                        label: function(context) {
                                            return `Duration: ${formatToHhMmSs(data[context.dataIndex].duration)}`;
                                        },
                                    }
                                }
                            }
                        }}
                    />
                ) : (
                    <Bar
                        data={{
                            labels: labels,
                            datasets: [{
                                data: oee.map(a => a.value),
                                backgroundColor: oee.map(a => a.color),
                                borderRadius: {
                                    topLeft: 4,
                                    topRight: 4
                                }
                            }]
                        }}
                        options={{
                            onHover: (event, chartElement) => {
                                if (chartElement[0] && chartElement[0].element) {
                                    if (hoveredId !== `${oee[chartElement[0].index].name} ${oee[chartElement[0].index].description}` && 
                                        `${data[chartElement[0].index].name} ${data[chartElement[0].index].description}` !== 'Other'
                                    ) {
                                        onHover(`${oee[chartElement[0].index].name} ${oee[chartElement[0].index].description}`)
                                    }
                                }
                                else {
                                    onHover(null)
                                }
                                
                            },
                            maintainAspectRatio: false,
                            scales: {
                                x: {
                                    display: false,
                                },
                                y: {
                                    // display: false,
                                    ticks: {
                                        callback: function(value, index, values) {
                                            if (values.length > 6) {
                                                if (index % 2 !== 0) {
                                                    return null;
                                                }
                                                else {
                                                    return value + "%";
                                                }
                                            }
                                            else {
                                                return value + "%";
                                            }
                                        }
                                    },
                                    border: {
                                        dash: [4, 5]
                                    },
                                }
                            },
                            plugins: {
                                legend: {
                                    display: false,
                                },
                                tooltip: {
                                    yAlign: "top",
                                    xAlign: "center",
                                    position: "nearest",
                                    backgroundColor: "#FFF",
                                    multiKeyBackground: "#fff",
                                    titleColor: "#111827",
                                    titleFont: {
                                        weight: 'bold',
                                        size: "14px",
                                    },
                                    bodyColor: "#666666",
                                    bodyFont: {
                                        weight: 'normal',
                                        // size: "14px",
                                    },
                                    boxWidth: 4,
                                    boxPadding: 4,
                                    borderColor: "rgba(122, 122, 122, 0.2)",
                                    borderWidth: 1,
                                    callbacks: {
                                        title: function(context) {
                                            return `Product: ${context[0].label}`;
                                        },
                                        label: function(context) {
                                            return `OEE: ${Number(context.formattedValue).toFixed(1)}%`;
                                        },
                                    }
                                }
                            }
                        }}
                    />
                )}
            </div>
            <div style={{ width: "100%", margin: "auto", marginLeft: "24px" }}>
                <TableContainer component={Paper} sx={{ height: "300px", marginTop: "-26px" }}>
                    <Table stickyHeader sx={{ minWidth: 650 }} aria-label="sku table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ background: "#F2F2F2", border: "none" }} sortDirection={orderBy === "name" ? order : false}>
                                    <TableSortLabel
                                        active={orderBy === 'name'}
                                        direction={orderBy === 'name' ? order : 'asc'}
                                        onClick={createSortHandler('name')}
                                        >
                                            SKU Name
                                        {orderBy === 'name' ? (
                                            <Box component="span" sx={{ display: "none"}}>
                                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                            </Box>
                                        ) : null}
                                    </TableSortLabel>
                                </TableCell>
                                <TableCell sx={{ background: "#F2F2F2", border: "none" }} sortDirection={orderBy === "description" ? order : false}>
                                    <TableSortLabel
                                        active={orderBy === 'description'}
                                        direction={orderBy === 'description' ? order : 'asc'}
                                        onClick={createSortHandler('description')}
                                        >
                                            SKU Description
                                        {orderBy === 'description' ? (
                                            <Box component="span" sx={{ display: "none"}}>
                                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                            </Box>
                                        ) : null}
                                    </TableSortLabel>
                                </TableCell>
                                <TableCell sx={{ background: "#F2F2F2", border: "none" }} sortDirection={orderBy === "duration" ? order : false}>
                                    <TableSortLabel
                                        active={orderBy === 'duration'}
                                        direction={orderBy === 'duration' ? order : 'asc'}
                                        onClick={createSortHandler('duration')}
                                        >
                                            Duration
                                        {orderBy === 'duration' ? (
                                            <Box component="span" sx={{ display: "none"}}>
                                                {order === 'duration' ? 'sorted descending' : 'sorted ascending'}
                                            </Box>
                                        ) : null}
                                    </TableSortLabel>
                                </TableCell>
                                <TableCell sx={{ background: "#F2F2F2", border: "none" }} sortDirection={orderBy === "oee" ? order : false}>
                                    <TableSortLabel
                                        active={orderBy === 'oee'}
                                        direction={orderBy === 'oee' ? order : 'asc'}
                                        onClick={createSortHandler('oee')}
                                        >
                                            OEE
                                        {orderBy === 'oee' ? (
                                            <Box component="span" sx={{ display: "none"}}>
                                                {order === 'oee' ? 'sorted descending' : 'sorted ascending'}
                                            </Box>
                                        ) : null}
                                    </TableSortLabel>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableData.map((item, i) => (
                                <TableRow
                                    onMouseEnter={() => onHover(i < 10 ? `${item.name} ${item.description}` : null)}
                                    onMouseLeave={() => onHover(null)}
                                    key={`${item.name} - ${item.description}`}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell sx={{ background: `${hoveredId === (item.name + ' ' + item.description) ? "#F2F2F2" : "#transparent"}` }}>{item.name}</TableCell>
                                    <TableCell sx={{ background: `${hoveredId === (item.name + ' ' + item.description) ? "#F2F2F2" : "#transparent"}` }}>{item.description}</TableCell>
                                    <TableCell sx={{ background: `${hoveredId === (item.name + ' ' + item.description) ? "#F2F2F2" : "#transparent"}` }}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <div style={{ width: "10px", height: "10px", background: tableBackgroundColors[item.duration_id], borderRadius: "100%", marginRight: "6px" }} />
                                            {formatToHhMmSs(item.duration)}
                                        </div>
                                    </TableCell>
                                    <TableCell sx={{ background: `${hoveredId === (item.name + ' ' + item.description) ? "#F2F2F2" : "#transparent"}` }}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <div style={{ width: "10px", height: "10px", background: tableBackgroundColors[item.efficiency_id], borderRadius: "100%", marginRight: "6px" }} />
                                            {item.oee}%
                                        </div>  
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    </TableContainer>
                

            </div>
        </div>
    )

}

export default TrendReportChartSKUBreakdown;